import { useState } from "react"
import { isAxiosError } from "axios"
import { useLoginService } from "./context"
import {
	AuthCredentials,
	AuthErrorResponseBody,
	AuthRequestParams
} from "./types"

export const useLoginFetcher = () => {
	const loginService = useLoginService()
	const [{ submitting, error }, setRequestState] = useState<FetcherState>(new FetcherState())

	const login = async (credentials: AuthCredentials, params?: AuthRequestParams) => {
		setRequestState({error: null, submitting: true})

		return loginService.login(loginService.toAuthPayload(credentials), params)
			.then((result) => {
				setRequestState({error: null, submitting: false})
				return result
			}).catch((error) => {
				isAxiosError(error) && setRequestState({submitting: false, error: error.response?.data})
				throw error
			})
	}

	return {
		login, submitting, error, cleanError: () => setRequestState((prevState) => ({...prevState, error: null}))
	}
}

class FetcherState {
	submitting: boolean = false
	error: AuthErrorResponseBody | null = null
}
